import React from 'react'
import { Row, Col } from 'reactstrap'
import { css } from 'aphrodite'

import Editor from '../../../partials/Editor'

import style from './style'

export const PostEditor = props => {
  if (!props.editor) {
    return null
  }

  return (
    <Row>
      <Col>
        <Row>
          <Col>
            <input
              type={`text`}
              value={props.editor.title}
              onChange={props.onTitleChange}
              className={css(
                style.input.input,
                style[props.theme.name]
                  ? style[props.theme.name].input.input
                  : null
              )}
            />
          </Col>
        </Row>
        <Row>
          <Col className={css(style.editor.editor)}>
            <Editor
              initialValue={props.editor.content}
              onHTMLChange={props.onContentChange}
            />
          </Col>
        </Row>
      </Col>
    </Row>
  )
}

export default PostEditor



// WEBPACK FOOTER //
// ./src/components/News/partials/PostEditor/index.js